import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./index";
import { apiSlice } from "../features/apiSlice";

const persistConfig = {
  key: "root",
  storage,
  version: 1,
  whitelist: [
    "user", 
    "token", 
    "permissions", 
    "params", 
    "crewRanks", 
    "mode", 
    "timemode", 
    "isSidebarOpen", 
    "language",
  ],
  blacklist: [
    "flights", 
    "crewRoutes", 
    "crewBlockHours", 
    apiSlice.reducerPath,
  ],
};

// Auth state stays flat at root (preserves all existing useSelector calls).
// RTK Query cache lives under state[apiSlice.reducerPath] ('api') alongside it.
const rootReducer = (state, action) => {
  const apiState = state?.[apiSlice.reducerPath];
  const authState = state ? (({ [apiSlice.reducerPath]: _, ...rest }) => rest)(state) : undefined;
  return {
    ...authReducer(authState, action),
    [apiSlice.reducerPath]: apiSlice.reducer(apiState, action),
  };
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(apiSlice.middleware),
  devTools: false,
});


export const persistor = persistStore(store);